import styled from "styled-components";

export const Chatbox = styled.article`
  position: fixed;
  bottom: 10vh;
  left: 15vw;
  max-height: 300px;
  width: 300px;
  background-color: rgba(0, 0, 0, 0.5);

  .messages {
    max-height: 180px;
    overflow-y: scroll;
    padding: 5px 10px;
  }
`;
